import {
  Modal,
  ModalBody,
  ModalFooterDefault,
  ModalHeaderDefault,
} from 'ui-components/dist/Modal';
import {
  Platforms,
  useEditPlatformsStore,
} from '~/screens/ManagePlatforms/EditPlatformsModal_DEPRECATED';

/**
 * @deprecated This component will be removed when we enable the foam_unverified_to_verified for everyone.
 */
export const EditPlatformsModal_DEPRECATED: React.FC = () => {
  const { isModalOpen, closeModal } = useEditPlatformsStore();

  return (
    <Modal isOpen={isModalOpen} onClose={closeModal} size="md">
      <ModalHeaderDefault title="Edit platforms" />

      <ModalBody>
        <Platforms />
      </ModalBody>

      <ModalFooterDefault
        secondary={{
          title: 'Close',
          onClick: () => {
            closeModal();
          },
        }}
      />
    </Modal>
  );
};
